(function () {
  const root = document.querySelector('.bagveda-collection-products');
  if (!root) return;

  const sortSelect = root.querySelector('[data-bagveda-collection-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  const filtersRoot = root.querySelector('[data-bagveda-collection-filters]');
  const openBtn = root.querySelector('[data-bagveda-collection-filters-open]');
  const closeTargets = root.querySelectorAll('[data-bagveda-collection-filters-close]');
  const filtersForm = root.querySelector('[data-bagveda-collection-filters-form]');

  const setFiltersOpen = (open) => {
    if (!filtersRoot || !openBtn) return;
    if (open) {
      filtersRoot.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('bagveda-collection-filters-open');
    } else {
      filtersRoot.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('bagveda-collection-filters-open');
    }
  };

  if (openBtn) {
    openBtn.addEventListener('click', () => setFiltersOpen(true));
  }

  closeTargets.forEach((el) => {
    el.addEventListener('click', () => setFiltersOpen(false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setFiltersOpen(false);
  });

  if (filtersForm) {
    filtersForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const url = new URL(window.location.href);
      const formData = new FormData(filtersForm);

      // Clear existing filter params, keep sort_by
      const sortBy = url.searchParams.get('sort_by');
      const query = url.searchParams.get('q');
      const searchType = url.searchParams.get('type');
      url.search = '';
      if (query) url.searchParams.set('q', query);
      if (searchType) url.searchParams.set('type', searchType);
      if (sortBy) url.searchParams.set('sort_by', sortBy);

      const grouped = {};
      formData.forEach((value, key) => {
        if (!value && value !== 0) return;
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(value);
      });

      Object.keys(grouped).forEach((key) => {
        if (key === 'q' || key === 'type' || key === 'sort_by') return;
        grouped[key].forEach((value) => {
          url.searchParams.append(key, value);
        });
      });

      window.location.href = url.toString();
    });
  }
})();
